import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../../environments/environment';

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

@Injectable({
  providedIn: 'root',
})
export class GaAnalyticsService {
  constructor(private readonly _router: Router) {
    if (!environment.ga_measurementId) {
      return;
    }
    this.injectGtag();
    this.trackPageViews();
  }

  private injectGtag(): void {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function (...args: unknown[]) {
      window.dataLayer.push(args);
    };
    window.gtag('js', new Date());
    window.gtag('config', environment.ga_measurementId);

    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${environment.ga_measurementId}`;
    document.head.appendChild(gtagScript);
  }

  private trackPageViews(): void {
    this._router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'page_view', {
            page_path: event.urlAfterRedirects,
            page_location: globalThis.window.location.href,
            page_title: document.title,
          });
        }
      });
  }

  /**
   *  Log a custom event
   *
   * @param {string} eventName - Name for Event.
   * @param {Record<string, any>} params - Paramaters to log.
   */
  public logEvent(eventName: string, params: Record<string, any> = {}): void {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
    }
  }

  /**
   *  Set user properties for Google Analytics 4
   *
   * @param {Record<string, any>} params - Paramaters to log.
   */
  public setUserProperties(properties: Record<string, any>): void {
    if (typeof window.gtag === 'function') {
      window.gtag('set', 'user_properties', properties);
    }
  }
}
